import { SearchProductFilters } from "@/models/product.model";
import { InventoryProductService } from "@/api/services/inventoryProduct.service";

const getProductsDashboard = ({ commit }: any, { filters }: { filters: SearchProductFilters }) => {
	return new Promise((resolve, reject) => {
		InventoryProductService.getDashboard({ filters })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

export default {
	getProductsDashboard
};
